import React, { useState } from 'react';
import Layout from './components/Layout';
import Button from '../../components/common/Button';
import { Playground, Control } from './components/Playground';
import Header from './components/Header';
import styles from './Button.module.css';

const ButtonPlayground = () => {
  const [buttonConfig, setButtonConfig] = useState({
    text: 'Button',
    type: 'fill',
    style: 'primary',
    size: 'medium',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setButtonConfig(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <Playground
      controls={
        <>
          <Control
            label="텍스트"
            name="text"
            value={buttonConfig.text}
            onChange={handleChange}
          />
          <Control
            label="타입"
            type="radio"
            name="type"
            value={buttonConfig.type}
            onChange={handleChange}
            options={[
              { value: 'fill', label: 'Fill' },
              { value: 'outline', label: 'Outline' },
              { value: 'text', label: 'Text' },
            ]}
          />
          <Control
            label="스타일"
            type="select"
            name="style"
            value={buttonConfig.style}
            onChange={handleChange}
            options={[
              { value: 'primary', label: 'Primary' },
              { value: 'secondary', label: 'Secondary' },
              { value: 'tertiary', label: 'Tertiary' },
              { value: 'negative', label: 'Negative' },
            ]}
          />
          <Control
            label="크기"
            type="select"
            name="size"
            value={buttonConfig.size}
            onChange={handleChange}
            options={[
              { value: 'large', label: 'Large' },
              { value: 'medium', label: 'Medium' },
              { value: 'small', label: 'Small' },
            ]}
          />
        </>
      }
      preview={
        <Button
          type={buttonConfig.type}
          style={buttonConfig.style}
          size={buttonConfig.size}
        >
          {buttonConfig.text}
        </Button>
      }
    />
  );
};

const ButtonDemo = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <Header 
          title="버튼"
          description="사용자의 행동을 유도하는 기본적인 버튼 컴포넌트입니다."
        />

        <ButtonPlayground />

        <section className={styles.demoSection}>
          <h2>타입</h2>
          <div className={styles.buttonGrid}>
            <Button>Fill Button</Button>
            <Button type="outline">Outline Button</Button>
            <Button type="text">Text Button</Button>
          </div>

          <h2>스타일</h2>
          <div className={styles.buttonGrid}>
            <Button style="primary">Primary</Button>
            <Button style="secondary">Secondary</Button>
            <Button style="tertiary">Tertiary</Button>
            <Button style="negative">Negative</Button>
          </div>

          <h2>크기</h2>
          <div className={styles.buttonGrid}>
            <Button size="large">Large</Button>
            <Button size="medium">Medium</Button>
            <Button size="small">Small</Button>
          </div>

          <h2>비활성화</h2>
          <div className={styles.buttonGrid}>
            <Button disabled>Disabled Button</Button>
            <Button type="outline" disabled>Disabled Outline</Button>
            <Button type="text" disabled>Disabled Text</Button>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default ButtonDemo; 